export default function ContactHero() {
    return (
      <section className="contact-hero">
  
        <img
          src="/contact-banner.png"
          alt="Contact RelyOnne"
          className="contact-banner-img"
        />
  
        <div className="contact-overlay">
          <div className="contact-hero-content">
  
            <span>GET IN TOUCH</span>
  
            <h1>Contact Us</h1>
  
            <p>
              We'd love to hear from you. Whether you need premium paper,
              packaging boards or custom sourcing solutions, our team is here
              to help.
            </p>
  
          </div>
        </div>
  
      </section>
    );
  }